export class Intermediario {



public cotizaciones: any[] = [];
public comisiones: any[] = [];
public clientes: any[] = [];

constructor(){}

}






// WEBPACK FOOTER //
// ./src/app/obj/intermediario.ts